/* eslint-disable @typescript-eslint/ban-types */
import { Container, Row, Col } from 'react-bootstrap';
import { SubmitHandler, UseFormReturn } from 'react-hook-form';
import { ContactPageProps } from '.';
import BreadcrumbComponent from '../../ui/Breadcrumb';
import FormInput from '../../ui/FormInput';
import SocialMedias from '../../ui/SocialMedias';
import { Styles } from './styles';
import ReCAPTCHA from 'react-google-recaptcha';
import { StyledButton } from '../RegisterPage/styles';
import { GenericError } from '../../../styles/error';
import ClientComponent from '../../ui/ClientComponent/ClientComponent';

interface ContactPageTemplateProps extends ContactPageProps {
  useFormData: UseFormReturn<ContactPageFormInputs>;
  onSubmit: SubmitHandler<ContactPageFormInputs>;
  captchaRef?: React.MutableRefObject<ReCAPTCHA | null>;
  sitekey?: string;
  setCaptcha?: (value?: string | null) => void;
  error: {
    field: string;
    message: string;
  };
  loading: boolean;
}

export interface ContactPageFormInputs {
  name: string;
  email: string;
  tel: string;
  subject: string;
  message: string;
}

const ContactPageTemplate: React.FC<ContactPageTemplateProps> = ({
  addressLine1,
  addressLine2,
  title,
  image,
  email,
  phone,
  facebookUrl,
  twitterUrl,
  linkedinUrl,
  youtubeUrl,
  instagramUrl,
  websiteUrl,
  useFormData,
  captchaRef,
  sitekey,
  setCaptcha,
  onSubmit,
  loading,
  error,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useFormData;

  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper contact-page">
        {/* Breadcroumb */}
        <BreadcrumbComponent title={title} image={image} />

        {/* Contact Area */}
        <section className="contact-area">
          <Container>
            <Row>
              <Col md="3">
                <div className="contact-box-title">
                  <h4>Informações</h4>
                </div>
                <div className="contact-icon-box d-flex">
                  <div className="icon">
                    <i className="las la-map-marker"></i>
                  </div>
                  <div className="box-content">
                    <h5>Nossa localização</h5>
                    {addressLine1 && <p>{addressLine1}</p>}
                    {addressLine2 && <p>{addressLine2}</p>}
                  </div>
                </div>

                {email ? (
                  <div className="contact-icon-box d-flex">
                    <div className="icon">
                      <i className="las la-envelope-open"></i>
                    </div>
                    <div className="box-content">
                      <h5>Email Address</h5>
                      <p>{email}</p>
                    </div>
                  </div>
                ) : null}

                {phone ? (
                  <div className="contact-icon-box d-flex">
                    <div className="icon">
                      <i className="las la-phone"></i>
                    </div>
                    <div className="box-content">
                      <h5>Telefone</h5>
                      <p>{phone}</p>
                    </div>
                  </div>
                ) : null}

                <div className="contact-social">
                  <SocialMedias
                    {...{
                      facebookUrl,
                      twitterUrl,
                      linkedinUrl,
                      youtubeUrl,
                      instagramUrl,
                      websiteUrl,
                    }}
                  />
                </div>
              </Col>
              <Col md="8" className="offset-md-1">
                <div className="contact-form">
                  <div className="form-title">
                    <h4>Como podemos te ajudar?</h4>
                  </div>
                  <div className="form-box">
                    <form id="form_contact" className="form" onSubmit={handleSubmit(onSubmit)}>
                      <Row>
                        <Col md="12">
                          <FormInput
                            type="text"
                            label="Nome Completo"
                            placeholder="Nome Completo"
                            name="name"
                            errors={errors['name']}
                            register={register('name', {
                              required: 'Por favor informe seu nome.',
                              minLength: { value: 3, message: 'Deve ter ao menos 3 caracteres.' },
                            })}
                          />
                        </Col>
                        <Col md="6">
                          <FormInput
                            type="email"
                            label="Email"
                            name="email"
                            placeholder="Email"
                            errors={errors['email']}
                            register={register('email', {
                              required: 'Por favor informe seu email.',
                            })}
                          />
                        </Col>
                        <Col md="6">
                          <FormInput
                            type="tel"
                            label="Telefone"
                            name="tel"
                            placeholder="Telefone"
                            errors={errors['tel']}
                            mask="(99) 9 9999-9999"
                            register={register('tel', {
                              required: 'Por favor informe seu telefone.',
                            })}
                          />
                        </Col>
                        <Col md="12">
                          <FormInput
                            type="text"
                            label="Assunto"
                            name="subject"
                            placeholder="Assunto"
                            errors={errors['subject']}
                            register={register('subject', {
                              required: 'Por favor informe um assunto.',
                            })}
                          />
                        </Col>
                        <Col md="12">
                          <FormInput
                            type="text"
                            label="Mensagem"
                            name="message"
                            rows={6}
                            placeholder="Mensagem"
                            errors={errors['message']}
                            register={register('message', {
                              required: 'Por favor informe uma mensagem.',
                            })}
                          />
                        </Col>
                        <ClientComponent>
                          <div className="my-4 recaptcha-area text-center">
                            <ReCAPTCHA sitekey={sitekey!} onChange={setCaptcha} ref={captchaRef} />
                          </div>
                        </ClientComponent>
                        {error?.field && error?.message && (
                          <GenericError className="mb-4 text-center">{error?.message}</GenericError>
                        )}
                        <Col md="12">
                          <StyledButton className="mb-3" type="submit" disabled={loading}>
                            ENVIAR
                            {loading && <div className="spinner-border" role="status"></div>}
                          </StyledButton>
                        </Col>
                      </Row>
                    </form>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Styles>
  );
};

export default ContactPageTemplate;
